import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type NotificationsStore = {
  showUnreadOnly: boolean;
  actions: {
    toggleShowUnreadOnly: () => void;
  };
};

const useNotificationsStore = create<NotificationsStore>()(
  persist(
    (set) => ({
      showUnreadOnly: false,
      actions: {
        toggleShowUnreadOnly: () =>
          set((state) => ({ showUnreadOnly: !state.showUnreadOnly })),
      },
    }),
    {
      name: 'notifications',
      partialize: (state) => ({
        showUnreadOnly: state.showUnreadOnly,
      }),
    },
  ),
);

export const useShowUnreadOnly = () =>
  useNotificationsStore((state) => state.showUnreadOnly);

export const useNotificationsActions = () =>
  useNotificationsStore((state) => state.actions);
